namespace GeniuzPOS.Administration {
    export interface PsSalesVatTypesRow {
        Id?: number;
        SalesVatType?: string;
        SalesVatTypeName?: string;
    }

    export namespace PsSalesVatTypesRow {
        export const idProperty = 'SalesVatType';
        export const nameProperty = 'SalesVatTypeName';
        export const localTextPrefix = 'Administration.PsSalesVatTypes';
        export const lookupKey = 'Administration.PsSalesVatTypes';

        export function getLookup(): Q.Lookup<PsSalesVatTypesRow> {
            return Q.getLookup<PsSalesVatTypesRow>('Administration.PsSalesVatTypes');
        }
        export const deletePermission = '1POSBASE:โปรไฟล์ของกิจการ:พารามิเตอร์ระบบ:Modify';
        export const insertPermission = '1POSBASE:โปรไฟล์ของกิจการ:พารามิเตอร์ระบบ:Modify';
        export const readPermission = '1POSBASE:โปรไฟล์ของกิจการ:พารามิเตอร์ระบบ:View';
        export const updatePermission = '1POSBASE:โปรไฟล์ของกิจการ:พารามิเตอร์ระบบ:Modify';

        export declare const enum Fields {
            Id = "Id",
            SalesVatType = "SalesVatType",
            SalesVatTypeName = "SalesVatTypeName"
        }
    }
}
